import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot, SlotProvider } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';
import { useCardContext } from './card-context.js';
import '@nettbureau/typography';

/**
 * Card headers arranges headings and buttons in the top of cards. They are optional when using
 * cards.
 */ const CardHeader = createPolymorphicComponent((props, ref)=>{
    const cardContext = useCardContext();
    const [mergedProps, mergedRef] = useSlot('CardHeader', props, ref);
    const { as: Component = 'div', children, className, css, layout, padding = cardContext?.padding } = mergedProps;
    const cardHeaderCss = useCss(({ mixins })=>[
            mixins.flex({
                align: 'center',
                ...layout
            }),
            mixins.spacing({
                padding
            })
        ]);
    const overrides = {
        Heading: {
            gutter: false,
            level: 5
        }
    };
    return /*#__PURE__*/ jsx(Component, {
        "data-card-header": true,
        ref: mergedRef,
        className: className,
        css: [
            cardHeaderCss,
            css
        ],
        children: /*#__PURE__*/ jsx(SlotProvider, {
            value: overrides,
            children: children
        })
    });
});

export { CardHeader };
//# sourceMappingURL=card-header.js.map
